export default __webpack_public_path__ + "static/media/Dharmesh_Poriya.55343e8f.jpg";